enum TraineeProfileStatus {
  PreRegistration = 0,
  Active = 1,
  Inactive = 2,
  Rejected = 3,
  Deceased = 4,
  Terminated = 5,
  Withdrawn = 6,
  Suspended = 7
}

enum trainingAppointmentStatus {
  Saved = 0,
  ReleasedTrainee = 11,
  Submitted = 21,
  ReSubmitted = 22,
  EndorsedCos = 61,
  ApprovedAdmin = 81,
  RejectedAdmin = 92
}

enum FellowProfileStatus {
  Active = 1,
  Deceased = 4,
  Terminated = 5,
  Withdrawn = 6
}

enum LockStatus {
  Unlock = 0,
  Locked = 1
}
enum MasterTableStatus {
  Active = 0,
  Inactive = 1
}
enum UserStatus {
  Active = 0,
  Inactive = 1
}
enum TrainingCentre {
  no = 0,
  yes = 1
}
enum CompletionStatus {
  Saved = 0,
  Released = 10,
  Submitted = 20,
  Endorsed = 60,
  Completed = 90
}

export const statusEnums = {
  TraineeProfileStatus,
  FellowProfileStatus,
  LockStatus,
  MasterTableStatus,
  TrainingCentre,
  UserStatus,
  trainingAppointmentStatus,
  CompletionStatus
}
